import { Box, Modal, Table } from '@mantine/core';
import CustomSearch from '../../../../../ui/search/customSearch';
import { useRef, useState } from 'react';
import useGetUsersByCompany from '../hooks/useGetUsersByCompany';
import { renderGradId, renderUserRole } from '../../../../../../shared/utils/role';

export default function UserListModal(props: {
  opened: boolean;
  onClose: () => void;
  companyId: number;
  serviceChannel: string;
}) {
  const { opened, onClose, companyId, serviceChannel } = props;
  const [page, setPage] = useState(1);
  const size = 10;
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchType, setSearchType] = useState('name');
  const [keyword, setKeyword] = useState('');

  const handleSearchType = (value: string) => {
    setSearchType(value);
  };

  const resetWord = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }

    setKeyword('');
    setPage(1);
  };

  const handleSearch = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLInputElement>) => {
    e.preventDefault();

    if (e.type === 'keyup' && 'key' in e && e.key !== 'Enter') {
      return;
    }

    setKeyword(inputRef.current?.value || '');
    setPage(1);
  };

  const { data } = useGetUsersByCompany({
    companyId,
    category: searchType,
    keyword,
    service: serviceChannel,
  });

  const renderMFMActiveStatus = (isActiveYn: string) => {
    return isActiveYn === 'Y' ? '활성화' : '비활성화';
  };

  const renderProutrActiveStatus = (approvalId: number) => {
    switch (approvalId) {
      case 11:
        return '활성화';
      case 21:
        return '비활성화';
      case 1:
        return '승인 대기';
      case 99:
        return '계정 삭제';
      default:
        return '알 수 없음';
    }
  };
  return (
    <Modal opened={opened} onClose={onClose} title="유저 상세" size="xl" centered>
      <Box mb="md">
        <CustomSearch
          resetSearch={resetWord}
          searchType={searchType}
          setSearchType={handleSearchType}
          inputRef={inputRef}
          handleSearch={handleSearch}
          searchOptions={[
            { value: 'name', label: '이름' },
            { value: 'id', label: '아이디' },
          ]}
        />
      </Box>
      <Table.ScrollContainer minWidth={700}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>번호</Table.Th>
              <Table.Th>이름</Table.Th>
              <Table.Th>권한</Table.Th>
              <Table.Th>아이디(이메일)</Table.Th>
              <Table.Th>상태</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.data && data.data.length > 0 ? (
              data?.data.map((item: any, index: number) => (
                <Table.Tr key={item.id}>
                  <Table.Td>{(data.total ?? 0) - ((page - 1) * size + (index ?? 0))}</Table.Td>
                  <Table.Td>{item.name}</Table.Td>
                  <Table.Td>
                    {serviceChannel.toLocaleLowerCase() === 'mfm' ? renderUserRole(item.userRoleCd) : renderGradId(item.gradeId)}
                  </Table.Td>
                  <Table.Td>{item.email}</Table.Td>
                  <Table.Td>
                    {serviceChannel.toLocaleLowerCase() === 'mfm'
                      ? renderMFMActiveStatus(item.isActiveYn)
                      : renderProutrActiveStatus(item.approvalId)}
                  </Table.Td>
                </Table.Tr>
              ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={5} align="center">
                  검색 결과가 없습니다.
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Modal>
  );
}
